import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { ShiftPatternEntity } from 'src/entities/ShiftPattern.entity';
import { TIME_RE } from 'src/pages/TruckShifts/cellEditor';
import { TimeSelectField } from 'src/pages/TruckShifts/presenters/TimeSelectField.presenter';

type Props = {
  patterns: ShiftPatternEntity[];
  onPickPattern: (id: number) => void;
  onAddCustom: (startTime: string, endTime: string) => void;
};

export const CellAddPicker: FC<Props> = ({ patterns, onPickPattern, onAddCustom }) => {
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  const canAdd = TIME_RE.test(startTime) && TIME_RE.test(endTime);

  return (
    <Stack spacing={1} sx={{ p: 1.5, width: 320 }}>
      <Typography variant="subtitle2" fontWeight={700}>便を選んで反映</Typography>
      <Typography variant="caption" color="text.secondary">行をクリックすると反映されます</Typography>
      {patterns.map((p) => {
        const timeLabel = p.slots.map((s) => `${s.startTime}-${s.endTime}`).join(' / ');
        const multiDaySuffix = p.multiDay && p.multiDayLength ? `・${p.multiDayLength}日` : '';
        return (
          <Box
            key={p.id}
            role="button"
            tabIndex={0}
            onClick={() => onPickPattern(p.id)}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onPickPattern(p.id); }}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 0.75,
              borderRadius: 1, cursor: 'pointer',
              '&:hover': { backgroundColor: 'action.hover' },
            }}
          >
            <Box sx={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: p.color, flexShrink: 0 }} />
            <Typography variant="body2" sx={{ flex: 1 }}>{p.name}{multiDaySuffix}</Typography>
            <Typography variant="caption" color="text.secondary">{timeLabel}</Typography>
          </Box>
        );
      })}
      <Divider />
      <Typography variant="caption" color="text.secondary">時間を直接入力して追加</Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <TimeSelectField label="開始" value={startTime} onChange={setStartTime} sx={{ flex: 1 }} />
        <TimeSelectField label="終了" value={endTime} onChange={setEndTime} sx={{ flex: 1 }} />
      </Stack>
      <Button
        size="small"
        variant="outlined"
        disabled={!canAdd}
        onClick={() => onAddCustom(startTime, endTime)}
      >
        追加
      </Button>
    </Stack>
  );
};
